const passwordRegex = new RegExp('^.{8,}$');

const validatePassword = (_, value) => {
  if (value && passwordRegex.test(value)) {
    return Promise.resolve();
  }

  return Promise.reject(new Error('Must be at least 8 characters long.'));
};

export const email = {
  validateTrigger: 'onSubmit',
  rules: [
    {
      type: 'email',
      message: 'Please enter a valid E-mail address.',
    },
    {
      required: true,
      message: 'Please enter your E-mail address.',
    },
  ],
};

export const firstName = {
  rules: [
    {
      required: true,
      message: 'Please enter your first name.',
      whitespace: true,
    },
  ],
};

export const lastName = {
  rules: [
    {
      required: true,
      message: 'Please enter your last name.',
      whitespace: true,
    },
  ],
};

export const password = {
  rules: [
    {
      required: true,
      message: 'Please enter a password.',
    },
    () => ({
      validator: validatePassword,
    }),
  ],
};

export const string = {
  rules: [
    {
      required: true,
      message: 'Please enter a value.',
      whitespace: true,
    },
  ],
};
